<div
  class="offcanvas offcanvas-end"
  data-bs-backdrop="default"
  tabindex="-1"
  id="staticBackdrop"
  aria-labelledby="staticBackdropLabel">
  <div class="offcanvas-header" style="display: flex; align-items: center; gap: 8px;">
    <h1 class="offcanvas-title" id="staticBackdropLabel">Mandat: #{{ current_mandat?.Md_BelegNr }}</h1>

    <!-- Prev button -->
    <button
      type="button"
      [disabled]="!hasPrevMandat"
      (click)="navigatePrevMandat()"
      class="btn btn-sm btn-outline-secondary"
      style="margin-left: 50px; padding: 4px 10px; line-height: 1;"
      title="Zurück">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" style="width: 22px; height: 22px;">
        <path fill-rule="evenodd" d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z" clip-rule="evenodd" />
      </svg>
    </button>

    <!-- Position label -->
    <span *ngIf="mandatPositionLabel" style="font-size: 14px; color: #888; white-space: nowrap;">{{ mandatPositionLabel }}</span>

    <!-- Next button -->
    <button
      type="button"
      [disabled]="!hasNextMandat"
      (click)="navigateNextMandat()"
      class="btn btn-sm btn-outline-secondary"
      style="padding: 4px 10px; line-height: 1;"
      title="Weiter">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" style="width: 22px; height: 22px;">
        <path fill-rule="evenodd" d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z" clip-rule="evenodd" />
      </svg>
    </button>

    <div style="flex: 1;"></div>
    <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5">
        <path
          fill-rule="evenodd"
          d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z"
          clip-rule="evenodd" />
      </svg>
    </button>
  </div>
  <div class="offcanvas-body">
    <router-outlet></router-outlet>
  </div>
</div>

<div class="d-flex">
  <div class="row setting-card-container mx-auto">
    <mat-card class="mat-elevation-z4 w-100">
      <mat-card-title>Mandate</mat-card-title>
      <mat-card-content>
        <div *ngIf="isLoading" style="display: flex; justify-content: center; align-items: center; background: white">
          <mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
        </div>

        <div class="filter-toolbar">
          <div class="filter-toolbar-inner">
            <span class="filter-inline-label">Suche:</span>
            <mat-form-field appearance="outline" class="compact-field filter-field">
              <input matInput (keyup)="applyFilter($event)" [(ngModel)]="searchValue" placeholder="" #input />
              <button
                mat-button
                *ngIf="searchValue"
                matSuffix
                mat-icon-button
                aria-label="Clear"
                (click)="clearSearch()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>

            <div class="filter-select-wrap" *ngFor="let empfilter of empFilters">
              <select
                class="filter-select"
                [(ngModel)]="empfilter.defaultValue"
                (change)="applyNativeFilter($event, empfilter)">
                <option *ngFor="let op of empfilter.options" [value]="op">{{ op }}</option>
              </select>
            </div>

            <button type="button" class="status-info-btn" (click)="openStatusInfo()" title="Status-Beschreibungen">
              <mat-icon style="font-size: 18px; width: 18px; height: 18px; line-height: 18px; color: #9ca3af;">info_outline</mat-icon>
            </button>

            <div class="filter-toolbar-spacer"></div>

            <div class="split-btn-group" *ngIf="editingAllowed">
              <button
                type="button"
                (click)="checkOverdue()"
                class="split-btn-main">
                Auf &Uuml;berfällig setzen
                <span *ngIf="selection.selected.length > 0">({{ selection.selected.length }})</span>
                <span *ngIf="selection.selected.length === 0">(alle)</span>
              </button>
              <button
                type="button"
                (click)="toggleDropdown($event)"
                class="split-btn-toggle">
                <svg viewBox="0 0 20 20" fill="currentColor" class="split-btn-arrow">
                  <path d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" fill-rule="evenodd" />
                </svg>
              </button>
              <div class="split-btn-menu" *ngIf="showDropdown">
                <a (click)="bulkSetMandateStatus('E')">Auf Erfasst setzen</a>
                <a (click)="bulkSetMandateStatus('T')">Auf Teil-erfasst setzen</a>
                <a (click)="bulkSetMandateStatus('U')">Auf Überfällig setzen</a>
                <a (click)="bulkSetMandateStatus('B')">Auf Bezahlt setzen</a>
                <a (click)="bulkSetMandateStatus('A')">Auf Angezeigt setzen</a>
                <a (click)="bulkSetMandateStatus('AB')">Auf Ang/Bez setzen</a>
                <a (click)="bulkSetMandateStatus('S')">Auf Storno setzen</a>
              </div>
            </div>
          </div>
        </div>

      <div class="example-container">
        <app-empty-state
          *ngIf="showNoActiveMandate"
          title="Keine aktiven Mandate"
          text="Derzeit sind keine aktiven Mandate vorhanden. Prüfen Sie den Transfer auf neue Einträge."
          buttonLabel="Zum Transfer"
          (action)="goToTransfer()">
        </app-empty-state>

        <app-empty-state
          *ngIf="showNoResults"
          title="Keine Einträge gefunden"
          text="Für die aktuelle Suche oder Filterauswahl wurden keine Mandate gefunden.">
        </app-empty-state>

        <table
          [hidden]="showEmptyState"
          mat-table
          [dataSource]="dataSource"
          class="mat-elevation-z0"
          matSort
          matSortActive="Md_PrimKey"
          matSortDisableClear
          matSortDirection="desc"
          matTableExporter
          #exporter="matTableExporter">
          <!----------------------------------------------------------------- -->

          <!-- Checkbox Column -->
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef style="width: 40px; padding: 0 4px;">
              <mat-checkbox
                (change)="$event ? masterToggle() : null"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()">
              </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row" style="width: 40px; padding: 0 4px;">
              <mat-checkbox
                (click)="$event.stopPropagation()"
                (change)="$event ? selection.toggle(row) : null"
                [checked]="selection.isSelected(row)">
              </mat-checkbox>
            </td>
          </ng-container>

          <!-- ID Column -->
          <ng-container matColumnDef="Md_PrimKey">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
            <td mat-cell *matCellDef="let row">{{ row.Md_PrimKey }}</td>
          </ng-container>

          <!-- Md_Status Column -->
          <ng-container matColumnDef="Md_Status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-column-100">Status</th>
            <td mat-cell *matCellDef="let row">
              <div
                *ngIf="row.Md_Status == 'A'"
                data-te-chip-init
                data-te-ripple-init
                class="chip-approved word-wrap: break-word] my-[5px] mr-4 flex h-[32px] cursor-pointer items-center justify-between rounded-[16px] bg-[#eceff1] px-[12px] py-0 text-[13px] font-normal normal-case leading-loose text-[#4f4f4f] shadow-none transition-[opacity] duration-300 ease-linear hover:!shadow-none active:bg-[#cacfd1] dark:bg-neutral-600 dark:text-neutral-200"
                data-te-close="true">
                ANGEZEIGT
              </div>

              <div
                *ngIf="row.Md_Status == 'T'"
                data-te-chip-init
                data-te-ripple-init
                class="chip-gray [word-wrap: break-word] my-[5px] mr-4 flex h-[32px] cursor-pointer items-center justify-between rounded-[16px] bg-[#eceff1] px-[12px] py-0 text-[13px] font-normal normal-case leading-loose text-[#4f4f4f] shadow-none transition-[opacity] duration-300 ease-linear hover:!shadow-none active:bg-[#cacfd1] dark:bg-neutral-600 dark:text-neutral-200"
                data-te-close="true">
                TEIL-ERFASST
              </div>

              <div
                *ngIf="row.Md_Status == 'E'"
                data-te-chip-init
                data-te-ripple-init
                class="chip-darkgray [word-wrap: break-word] my-[5px] mr-4 flex h-[32px] cursor-pointer items-center justify-between rounded-[16px] bg-[#eceff1] px-[12px] py-0 text-[13px] font-normal normal-case leading-loose text-[#4f4f4f] shadow-none transition-[opacity] duration-300 ease-linear hover:!shadow-none active:bg-[#cacfd1] dark:bg-neutral-600 dark:text-neutral-200"
                data-te-close="true">
                ERFASST
              </div>

              <div
                *ngIf="row.Md_Status == 'U'"
                data-te-chip-init
                data-te-ripple-init
                class="chip-overdue [word-wrap: break-word] my-[5px] mr-4 flex h-[32px] cursor-pointer items-center justify-between rounded-[16px] bg-[#eceff1] px-[12px] py-0 text-[13px] font-normal normal-case leading-loose text-[#4f4f4f] shadow-none transition-[opacity] duration-300 ease-linear hover:!shadow-none active:bg-[#cacfd1] dark:bg-neutral-600 dark:text-neutral-200"
                data-te-close="true">
                ÜBERFÄLLIG
              </div>

              <div
                *ngIf="row.Md_Status == 'B'"
                data-te-chip-init
                data-te-ripple-init
                class="chip-active-fsdone [word-wrap: break-word] my-[5px] mr-4 flex h-[32px] cursor-pointer items-center justify-between rounded-[16px] bg-[#eceff1] px-[12px] py-0 text-[13px] font-normal normal-case leading-loose text-[#4f4f4f] shadow-none transition-[opacity] duration-300 ease-linear hover:!shadow-none active:bg-[#cacfd1] dark:bg-neutral-600 dark:text-neutral-200"
                data-te-close="true">
                BEZAHLT
              </div>

              <div
                *ngIf="row.Md_Status == 'AB'"
                data-te-chip-init
                data-te-ripple-init
                class="chip-warn [word-wrap: break-word] my-[5px] mr-4 flex h-[32px] cursor-pointer items-center justify-between rounded-[16px] bg-[#eceff1] px-[12px] py-0 text-[13px] font-normal normal-case leading-loose text-[#4f4f4f] shadow-none transition-[opacity] duration-300 ease-linear hover:!shadow-none active:bg-[#cacfd1] dark:bg-neutral-600 dark:text-neutral-200"
                data-te-close="true">
                ANG/BEZ
              </div>

              <div
                *ngIf="row.Md_Status == 'S'"
                data-te-chip-init
                data-te-ripple-init
                class="chip-lightgray [word-wrap: break-word] my-[5px] mr-4 flex h-[32px] cursor-pointer items-center justify-between rounded-[16px] bg-[#eceff1] px-[12px] py-0 text-[13px] font-normal normal-case leading-loose text-[#4f4f4f] shadow-none transition-[opacity] duration-300 ease-linear hover:!shadow-none active:bg-[#cacfd1] dark:bg-neutral-600 dark:text-neutral-200"
                data-te-close="true">
                STORNO
              </div>

              <div
                *ngIf="row.Md_Status == '8'"
                data-te-chip-init
                data-te-ripple-init
                class="chip-warn [word-wrap: break-word] my-[5px] mr-4 flex h-[32px] cursor-pointer items-center justify-between rounded-[16px] bg-[#eceff1] px-[12px] py-0 text-[13px] font-normal normal-case leading-loose text-[#4f4f4f] shadow-none transition-[opacity] duration-300 ease-linear hover:!shadow-none active:bg-[#cacfd1] dark:bg-neutral-600 dark:text-neutral-200"
                data-te-close="true">
                AUSGENOMMEN
              </div>

              <div
                *ngIf="row.Md_Status == '9'"
                data-te-chip-init
                data-te-ripple-init
                class="chip-error [word-wrap: break-word] my-[5px] mr-4 flex h-[32px] cursor-pointer items-center justify-between rounded-[16px] bg-[#eceff1] px-[12px] py-0 text-[13px] font-normal normal-case leading-loose text-[#4f4f4f] shadow-none transition-[opacity] duration-300 ease-linear hover:!shadow-none active:bg-[#cacfd1] dark:bg-neutral-600 dark:text-neutral-200"
                data-te-close="true">
                ERROR
              </div>
            </td>
          </ng-container>

          <!-- Profilbild Column
          <ng-container matColumnDef="profile_image">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-column-50">&nbsp;</th>
            <td mat-cell *matCellDef="let row">
              <phuture-iavatar src_image="{{ imageStorage }}{{ row.profile_image }}"></phuture-iavatar>
            </td>
          </ng-container>
          -->

          <!-- Md_BelegNr Column -->
          <ng-container matColumnDef="Md_BelegNr">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-column-80">Aktenzeichen</th>
            <td mat-cell *matCellDef="let row" class="font-semibold">&nbsp;{{ row.Md_BelegNr }}&nbsp;</td>
          </ng-container>

          <!----------------------------------------------------------------- -->

          <!-- Tatdatum Column | date -->
          <ng-container matColumnDef="Md_Datum">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Datum</th>
            <td mat-cell *matCellDef="let row">&nbsp;{{ row.Md_Datum }}&nbsp;</td>
          </ng-container>

          <!-- Tatzeit Column | date : 'shortTime' -->
          <ng-container matColumnDef="Md_ZeitVon">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Zeit</th>
            <td mat-cell *matCellDef="let row">&nbsp;{{ row.Md_ZeitVon }}&nbsp;</td>
          </ng-container>

          <!-- Md_KzLand Column -->
          <ng-container matColumnDef="Md_KzLand">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Land</th>
            <td mat-cell *matCellDef="let row">&nbsp;{{ row.Md_KzLand }}&nbsp;</td>
          </ng-container>

          <!-- Md_KzBezirk Column
          <ng-container matColumnDef="Md_KzBezirk">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Bezirk</th>
            <td mat-cell *matCellDef="let row">{{ row.Md_KzBezirk }}</td>
          </ng-container>
          -->

          <!-- Md_KzNummer Column -->
          <ng-container matColumnDef="Md_KzNummer">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Kennzeichen</th>
            <td mat-cell *matCellDef="let row">{{ row.Md_KzNummer }}</td>
          </ng-container>

          <!-- Md_Hersteller Column -->
          <ng-container matColumnDef="Md_Hersteller">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Hersteller</th>
            <td mat-cell *matCellDef="let row">{{ row.Md_Hersteller }}</td>
          </ng-container>

          <!-- Md_TatbestNr / Delikt Column -->
          <ng-container matColumnDef="Md_TatbestNr">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Delikt</th>
            <td mat-cell *matCellDef="let row">&nbsp;{{ parseDelikt(row.Md_TatbestNr) }}&nbsp;</td>
          </ng-container>

          <!-- bom Column -->
          <ng-container matColumnDef="bom">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-column-80">BOM</th>
            <td mat-cell *matCellDef="let row">
              <div
                *ngIf="row.bom == 1"
                data-te-chip-init
                data-te-ripple-init
                class="chip-bom [word-wrap: break-word] my-[5px] mr-4 flex h-[32px] cursor-pointer items-center justify-between rounded-[16px] bg-[#4caf50] px-[12px] py-0 text-[13px] font-normal normal-case leading-loose text-white shadow-none transition-[opacity] duration-300 ease-linear hover:!shadow-none active:bg-[#388e3c] dark:bg-neutral-600 dark:text-neutral-200"
                data-te-close="true">
                BOM
              </div>
              <div
                *ngIf="row.bom == 0 || !row.bom"
                data-te-chip-init
                data-te-ripple-init
                class="chip-anzeige [word-wrap: break-word] my-[5px] mr-4 flex h-[32px] cursor-pointer items-center justify-between rounded-[16px] bg-[#2196f3] px-[12px] py-0 text-[13px] font-normal normal-case leading-loose text-white shadow-none transition-[opacity] duration-300 ease-linear hover:!shadow-none active:bg-[#1976d2] dark:bg-neutral-600 dark:text-neutral-200"
                data-te-close="true">
                Anzeige
              </div>
            </td>
          </ng-container>

          <!-- Md_Betrag Column -->
          <ng-container matColumnDef="Md_Betrag">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Betrag</th>
            <td mat-cell *matCellDef="let row">{{ row.Md_Betrag }}</td>
          </ng-container>

          <!-- Md_DienstNr Column -->
          <ng-container matColumnDef="Md_DienstNr">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Dienst-Nr</th>
            <td mat-cell *matCellDef="let row">{{ row.Md_DienstNr }}</td>
          </ng-container>

          <!----------------------------------------------------------------- -->

          <!-- actions button bar Column -->

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
            <td mat-cell *matCellDef="let row">
              <button
                type="button"
                matRipple
                [matRippleColor]="'rgb(103, 121, 189, 0.5)'"
                  class="text-white text-sm py-1 px-3 rounded"
                  style="background-color: #4358a6;"
                  onmouseover="this.style.backgroundColor='#374a8a'"
                  onmouseout="this.style.backgroundColor='#4358a6'"
                  (click)="showPageDetail(row.Md_PrimKey)">
                  Ansehen
              </button>
            </td>
            <td mat-footer-cell *matFooterCellDef="let row">&nbsp;</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            mat-row
            *matRowDef="let emprow; columns: displayedColumns"
            (click)="showPageDetail(emprow.Md_PrimKey)"></tr>
        </table>

        <mat-paginator
          #paginator
          [hidden]="showEmptyState"
          [length]="totalItems"
          [pageSizeOptions]="pageSizes"
          showFirstLastButtons></mat-paginator>
      </div>
      <p>&nbsp;</p>
      </mat-card-content>
    </mat-card>
  </div>
</div>
